import React from "react";
import { useI18n } from "@/context/I18nContext";

// Farb-Töne pro Aufgaben-Status
export const STATUS_TONE = {
  offen: "border-[#A3E635]/40 bg-[#A3E635]/10 text-[#A3E635]",
  in_arbeit: "border-blue-400/40 bg-blue-400/10 text-blue-300",
  warten_auf_kunde: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  pruefung: "border-violet-400/40 bg-violet-400/10 text-violet-300",
  erledigt: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  archiviert: "border-white/15 bg-white/5 text-gray-400",
};

export const PRIORITIES = [["niedrig", "Niedrig"], ["mittel", "Mittel"], ["hoch", "Hoch"]];
export const PRIO_TONE = {
  hoch: "text-red-300 bg-red-400/10 border-red-400/30",
  mittel: "text-gray-300 bg-white/5 border-white/10",
  niedrig: "text-gray-400 bg-white/5 border-white/10",
};

export const VIS_TONE = {
  intern: "text-gray-300 bg-white/5 border-white/10",
  kundensichtbar: "text-sky-300 bg-sky-400/10 border-sky-400/30",
  freigabe: "text-amber-300 bg-amber-400/10 border-amber-400/30",
  kundenhinweis: "text-teal-300 bg-teal-400/10 border-teal-400/30",
};

export const StatusPill = ({ status, label, testid }) => (
  <span data-testid={testid} className={`text-[11px] px-2.5 py-1 rounded-full border font-semibold whitespace-nowrap ${STATUS_TONE[status] || STATUS_TONE.archiviert}`}>
    {label || status}
  </span>
);

export const PrioPill = ({ p, label }) => (
  <span className={`text-[10px] px-2 py-0.5 rounded-full border font-bold uppercase tracking-wide ${PRIO_TONE[p] || PRIO_TONE.mittel}`}>{label || p || "mittel"}</span>
);

export const VisPill = ({ v, label, testid }) => (
  <span data-testid={testid} className={`text-[10px] px-2 py-0.5 rounded-full border font-bold ${VIS_TONE[v] || VIS_TONE.intern}`}>{label || v}</span>
);

export const Progress = ({ done, total }) => {
  if (!total) return <span className="text-xs text-gray-600">—</span>;
  const pct = Math.round((done / total) * 100);
  return (
    <div className="flex items-center gap-2 min-w-[80px]">
      <div className="flex-1 h-1.5 rounded-full bg-white/10 overflow-hidden">
        <div className="h-full rounded-full bg-[#A3E635]" style={{ width: `${pct}%` }} />
      </div>
      <span className="text-[11px] text-gray-400 tabular-nums">{done}/{total}</span>
    </div>
  );
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return iso; }
};

export const KundeAmZug = ({ testid }) => {
  const { t } = useI18n();
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full border border-amber-400/40 bg-amber-400/10 text-amber-300 whitespace-nowrap">
      {t("Kunde am Zug")}
    </span>
  );
};

export const inputCls = "w-full min-h-[44px] bg-black border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A3E635] transition-colors";
